var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './styles.module.scss';
import { withAliases } from '../../../ui/utils/with-aliases';
var BaseIconButton = function (_a) {
    var _b;
    var _c = _a.size, size = _c === void 0 ? 'xl' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, Icon = _a.Icon, className = _a.className, _e = _a.type, type = _e === void 0 ? 'button' : _e, children = _a.children, rest = __rest(_a, ["size", "disabled", "Icon", "className", "type", "children"]);
    var buttonClasses = classNames(styles['icon-button'], styles["icon-button--".concat(size)], (_b = {},
        _b[styles['icon-button--disabled']] = disabled,
        _b), className);
    return (_jsxs("button", __assign({ className: buttonClasses, disabled: disabled, type: type }, rest, { children: [_jsx("div", { className: styles.icon, children: Icon }), children] })));
};
var XL = function (props) { return _jsx(BaseIconButton, __assign({ size: "xl" }, props)); };
var L = function (props) { return _jsx(BaseIconButton, __assign({ size: "l" }, props)); };
var M = function (props) { return _jsx(BaseIconButton, __assign({ size: "m" }, props)); };
var S = function (props) { return _jsx(BaseIconButton, __assign({ size: "s" }, props)); };
var XS = function (props) { return _jsx(BaseIconButton, __assign({ size: "xs" }, props)); };
export var IconButton = withAliases(BaseIconButton, {
    XL: XL,
    L: L,
    M: M,
    S: S,
    XS: XS,
});
